import { createSvgComponent } from "../../icon/createSvgComponent";
import TabMoreLeft from "@core/icon/assets/tab-more-left.svg";
export default createSvgComponent(TabMoreLeft);